/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TestHookActionResult
 */
export interface TestHookActionResult {
    /**
     * 
     * @type {boolean}
     * @memberof TestHookActionResult
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TestHookActionResult
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof TestHookActionResult
     */
    error?: string;
}

/**
 * Check if a given object implements the TestHookActionResult interface.
 */
export function instanceOfTestHookActionResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TestHookActionResultFromJSON(json: any): TestHookActionResult {
    return TestHookActionResultFromJSONTyped(json, false);
}

export function TestHookActionResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestHookActionResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': !exists(json, 'success') ? undefined : json['success'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function TestHookActionResultToJSON(value?: TestHookActionResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'message': value.message,
        'error': value.error,
    };
}

